import React, { useContext } from 'react'
import { SpinnerContext } from './SpinnerContext'
import { Spinner as RBSpinner } from 'react-bootstrap'
import './style.scss'

export const Spinner = () => {
  const { spinners } = useContext(SpinnerContext)

  /** 是否顯示 flag */
  const show = spinners.length > 0

  /** 取最後一個 Spinner 來顯示 */
  const spinner = spinners.length > 0 ? spinners[spinners.length - 1] : null

  if (!show || !spinner) return null

  return (
    <div className='spinner-wrapper'>
      <div className='spinner-backdrop'>
        <RBSpinner animation='border' />
        {spinner.message || '處理中...'}
      </div>
    </div>
  )
}
